var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{attrs:{"data-cy":"emp-holidays-report-table-row"}},[_c('td',[_vm._v(_vm._s(_vm.holiday.full_name))]),_c('td',[_vm._v(_vm._s(_vm.departmentName))]),_c('td',[_vm._v(_vm._s(_vm.employeeCode))]),_c('td',[_vm._v(_vm._s(_vm.holidayName))]),_c('td',[_vm._v(_vm._s(_vm.Holiday))])])
}
var staticRenderFns = []

export { render, staticRenderFns }